<div class="chart-container">
  <div *ngIf="chartView === 'chartType1'" class="chart-view">
    <div class="d-flex justify-content-between align-items-center"> <h4 translate>TOTALVIEW</h4>
      <span *ngIf="deviationListCount !== undefined && deviationListCount !== null" class="total-count-display">
        {{ 'TOTALVIEW' | translate: { count: deviationListCount } }}
      </span>
    </div>
    <div class="pie-chart-wrapper">
      <ngx-charts-advanced-pie-chart
        [view]="view"
        [scheme]="colorScheme"
        [results]="single"
        [gradient]="gradient"
      >
      </ngx-charts-advanced-pie-chart>
    </div>
  </div>

  <!-- Bar-Chart: Type 2 Deviations per department-->
  <!-- Only visible in Business level, this is replaced in portal level -->
  <div *ngIf="chartView === 'chartType2' && !isPortal" class="chart-view">
    <h4 translate>DEVIATIONS_PER_DEPARTMENT</h4>
    <div class="vertical-stacked">
      <ngx-charts-bar-vertical-stacked
        [scheme]="colorScheme"
        [results]="paginatedDepartmentData"
        [gradient]="gradient"
        [legendTitle]="legendTitle"
        [xAxis]="true"
        [yAxis]="true"
        [legend]="showLegend"
        [showXAxisLabel]="false"
        [showYAxisLabel]="false"
        [maxXAxisTickLength]="12"
        xAxisLabel="Department"
        yAxisLabel="Count"
      >
      </ngx-charts-bar-vertical-stacked>
      <div class="d-flex justify-content-end pb-1">
        <button
          class="btn btn-outline-secondary"
          type="button"
          translate
          (click)="prevPage('department')"
        >
          BACK
        </button>
        <button
          class="btn btn-outline-primary"
          type="button"
          translate
          (click)="nextPage('department')"
        >
          NEXT
        </button>
      </div>
    </div>
  </div>

  <!-- Bar-Chart: Type 2 Deviations per business-->
  <!-- Only visible in Portal level, this is replaced in business level -->
  <div *ngIf="chartView === 'chartType2' && isPortal" class="chart-view">
    <h4 translate>DEVIATIONS_PER_BUSINESS</h4>
    <div class="vertical-stacked">
      <ngx-charts-bar-vertical-stacked
        [scheme]="colorScheme"
        [results]="paginatedBusinessData"
        [gradient]="gradient"
        [legendTitle]="legendTitle"
        [xAxis]="true"
        [yAxis]="true"
        [legend]="showLegend"
        [showXAxisLabel]="false"
        [showYAxisLabel]="false"
        [maxXAxisTickLength]="12"
        xAxisLabel="Business"
        yAxisLabel="Count"
      >
      </ngx-charts-bar-vertical-stacked>
      <div class="d-flex justify-content-end pb-1">
        <button
          class="btn btn-outline-secondary"
          type="button"
          translate
          (click)="prevPage('business')"
        >
          BACK
        </button>
        <button
          class="btn btn-outline-primary"
          type="button"
          translate
          (click)="nextPage('business')"
        >
          NEXT
        </button>
      </div>
    </div>
  </div>

  <!-- Bar-Chart: Type 3 Deviations per importance-->
  <div *ngIf="chartView === 'chartType3'" class="chart-view">
    <h4 translate>DEVIATIONS_PER_IMPORTANCE</h4>
    <div class="pie-chart-wrapper">
      <div class="circles">
        <ngx-charts-pie-grid
          [view]="view"
          [scheme]="colorSchemeImportance"
          [results]="importanceData"
        >
        </ngx-charts-pie-grid>
      </div>
    </div>
  </div>
</div>
